/**
 * Summary:
 * All configurables are listed here...
 * 
 */

export const ERoles = {
    "REGIONALUSER": {
        id: 0,
        label: "Regional User"
    },
    "COORDINATOR": {
        id: 1,
        label: "Regional Coordinator"
    },
    "TCPSSME": {
        id: 2,
        label: "TCPS SME"
    },
    "ADMIN":{
        id: 2,
        label: "TCPS SME"
    },
    "SYSTEMADMIN": {
        id: 3,
        label: "System Admin"
    },
    "OPERATIONADMIN": {
        id: 4,
        label: "Operation Admin"
    }
} 

export const tabForm = {
    "roadsNpmInfraDTO": "Infraestructure",
    "roadsNpmTentcompDTO": "TENT Compliance",
    "roadsNpmOpsDTO": "Operations",
    "roadsNpmSafetyDTO": "Safety",
    "roadsNpmMaintDTO": "Maintenance",
    "roadsNpmEnvDTO": "Environmental Impact",
    "roadsNpmClimateDTO": "Climate resilience",
    "roadsLiveNmDTO": "MP",
    "roadsLivePmDescDTO": "Description",
    "roadsLivePmEligiTentDTO": "TENT Project",
    "roadsLivePmIndicatorsDTO": "Indicators",
    "roadsLivePmPiDTO": "Perfomance Indicators",
    "roadsLivePmStatusDTO": "Status",
    "roadsLivePmTentcompDTO":"TENT Compliance",
    "roadsImpNmDTO":"MP",
    "roadsImpPmDescDTO":"Description",
    "roadsImpPmEligiTentDTO": "TENT Project",
    "roadsImpPmIndicatorsDTO": "Indicators",
    "roadsImpPmPiDTO": "Perfomance Indicators",
    "roadsImpPmStatusDTO": "Status",
    "roadsImpPmTentcompDTO":"TENT Compliance",
    "railwaysNpmInfraDTO": "Infraestructure",
    "railwaysNpmTentcompDTO": "TENT Compliance",
    "railwaysNpmOpsDTO": "Operations",
    "railwaysNpmSafetyDTO": "Safety",
    "railwaysNpmMaintDTO": "Maintenance",
    "railwaysNpmEnvDTO": "Environmental Impact",
    "railwaysNpmClimateDTO": "Climate resilience",
    "railwaysImpPmDescDTO" : "Description",
    "railwaysImpPmEligiTentDTO":"TENT Project",
    "railwaysImpPmIndicatorsDTO":"Indicators",
    "railwaysImpPmPiDTO":"Perfomance Indicators",
    "railwaysImpPmStatusDTO":"Status",
    "railwaysImpPmTentcompDTO":"TENT Compliance",
    "railwaysLivePmDescDTO":"Description",
    "railwaysLivePmEligiTentDTO":"TENT Project",
    "railwaysLivePmIndicatorsDTO":"Indicators",
    "railwaysLivePmPiDTO":"Perfomance Indicators",
    "railwaysLivePmStatusDTO":"Status",
    "railwaysLivePmTentcompDTO":"TENT Compliance"
}

export const tabFormName = {
    1: "Airport Implement Project Monitoring",
    2: "Airport Live Project Monitoring",
    3: "Airport Network Perfomance",
    4: "Freight Implement Project Monitoring",
    5: "Freight Live Project Monitoring",
    6: "Freight Network Perfomance",
    7: "IWW Implement Project Monitoring",
    8: "IWW Live Project Monitoring",
    9: "IWW Network Perfomance",
    10: "IWWPORTS Implement Project Monitoring",
    11: "IWWPORTS Live Project Monitoring",
    12: "IWWPORTS Network Perfomance",
    13:"Railways Implement Project Monitoring",
    14:"Railways Live Project Monitoring",
    15:"Railways Network Perfomance",
    16:"Road Implement Project Monitoring",
    17:"Road Live Project Monitoring",
    18:"Road Network Perfomance",
    19:"Seaports Implement Project Monitoring",
    20:"Seaports Live Project Monitoring",
    21:"Seaports Network Perfomance",
    22:"Railways Border crossing",
    24:"Roads Border crossing",
    23:"EU Acquis"
}

export const ReguionalPartnerName = {
    76: "Serbia", 
    77: "Kosovo*",
    78: "Albania",
    79: "Bosnia and Herzegovina",
    81: "Montenegro",
    82: "North Macedonia"
}
export const UrlServices = {
    "ROADNPM": "https://todis.transport-community.org/server/rest/services/Todis_Roads/MapServer/12/query",
    // "ROADNPM": "https://arcgis-itconsulting.idom.com/server/rest/services/TODIS/Todis_Roads/MapServer/12/query",
    "ROADIMP": "https://todis.transport-community.org/server/rest/services/Todis_Roads/MapServer/8/query",
    "ROADLIVE": "https://todis.transport-community.org/server/rest/services/Todis_Roads_LRS/MapServer/7/query",    
    "RAILWAYSNPM": "https://todis.transport-community.org/server/rest/services/Todis_Railways/MapServer/3/query",
    "RAILWAYSIMP": "https://todis.transport-community.org/server/rest/services/Todis_Railways/MapServer/2/query",
    "RAILWAYSLIVE": "https://todis.transport-community.org/server/rest/services/Todis_Railways/MapServer/1/query",
    "IWWNPM": "https://todis.transport-community.org/server/rest/services/Todis_IWW/MapServer/8/query",
    "IWWIMP": "https://todis.transport-community.org/server/rest/services/Todis_IWW/MapServer/10/query",
    "IWWLIVE": "https://todis.transport-community.org/server/rest/services/Todis_IWW/MapServer/9/query",
    "IWWPORTSNPM": "https://todis.transport-community.org/server/rest/services/Todis_IWW_Ports/MapServer/2/query",
    "IWWPORTSIMP": "https://todis.transport-community.org/server/rest/services/Todis_IWW_Ports/MapServer/0/query",
    "IWWPORTSLIVE": "https://todis.transport-community.org/server/rest/services/Todis_IWW_Ports/MapServer/1/query",
    "AIRPORTSNPM": "https://todis.transport-community.org/server/rest/services/Todis_Airports/MapServer/2/query",
    "AIRPORTSIMP": "https://todis.transport-community.org/server/rest/services/Todis_Airports/MapServer/3/query",
    "AIRPORTSLIVE": "https://todis.transport-community.org/server/rest/services/Todis_Airports/MapServer/1/query",
    "SEAPORTSNPM": "https://todis.transport-community.org/server/rest/services/Todis_Seaports/MapServer/3/query",
    "SEAPORTSIMP": "https://todis.transport-community.org/server/rest/services/Todis_Seaports/MapServer/0/query",
    "SEAPORTSLIVE": "https://todis.transport-community.org/server/rest/services/Todis_Seaports/MapServer/1/query",
    "FREIGHTNPM": "https://todis.transport-community.org/server/rest/services/Todis_Freight/MapServer/2/query",
    "FREIGHTIMP": "https://todis.transport-community.org/server/rest/services/Todis_Freight/MapServer/0/query",
    "FREIGHTLIVE": "https://todis.transport-community.org/server/rest/services/Todis_Freight/MapServer/3/query",
    "URBANNPM": "https://todis.transport-community.org/server/rest/services/Todis_Freight/MapServer/2/query",
    "ROADSSBORDERNPM":"https://todis.transport-community.org/server/rest/services/Todis_Border/MapServer/1/query",
    "RAILWAYSBORDERNPM":"https://todis.transport-community.org/server/rest/services/Todis_Border/MapServer/3/query"
}
export const UrlServicesFiltrosView = {
    "ROADNPM": "todis.arcgis.Road_NPM_Sections.npm_road_id",
    // "ROADNPM": "npm_road_id",
    "ROADIMP": "todis.arcgis.Road_Imp_PM_Sections.imp_road_proj_id",
    "ROADLIVE": "todis.arcgis.Road_Live_PM_Sections.live_road_proj_id",
    // "ROADLIVE": "todisdb.arcgis.Road_Live_PM_Sections.live_road_proj_id", 
    "RAILWAYSNPM": "todis.arcgis.RW_NPM_Sections.npm_rw_id",
    "RAILWAYSIMP": "todis.arcgis.RW_Ipm_PM_Sections.imp_rw_proj_id",
    "RAILWAYSLIVE": "todis.arcgis.RW_Live_PM_Sections.live_rw_proj_id",
    "IWWNPM": "todis.arcgis.IWW_NPM_Sections.npm_iww_id",
    "IWWIMP": "todis.arcgis.IWW_Imp_PM_Sections.imp_iww_proj_id",
    "IWWLIVE": "todis.arcgis.IWW_Live_PM_Sections.live_iww_proj_id"
    
}
export const UrlServicesFiltros = {
    "AIRPORTSNPM": "npm_airports_id",
    "AIRPORTSLIVE": "live_airports_proj_id",
    "AIRPORTSIMP": "imp_airports_proj_id",
    "SEAPORTSNPM": "npm_seaports_id",
    "SEAPORTSLIVE": "live_seaports_proj_id",
    "SEAPORTSIMP": "imp_seaports_proj_id",
    "FREIGHTNPM": "npm_freight_id",
    "FREIGHTLIVE": "live_freight_proj_id",
    "FREIGHTIMP": "imp_freight_proj_id",
    "URBANNPM": "npm_urban_id",
    "IWWPORTSNPM": "npm_iww_ports_id",
    "IWWPORTSLIVE": "live_iww_ports_proj_id",
    "IWWPORTSIMP": "imp_iww_ports_proj_id",    
    "ROADSSBORDERNPM":"npm_roads_border_cross_id",
    "RAILWAYSBORDERNPM":"npm_rw_border_cross_id"
}
export const UrlServicesId = {
    "ROADNPM": "npmRoadId",
    "ROADIMP": "impRoadProjId",
    "ROADLIVE": "liveRoadProjId",    
    "RAILWAYSNPM": "npmRwId",
    "RAILWAYSIMP": "impRwProjId",
    "RAILWAYSLIVE": "liveRwProjId",
    "IWWNPM": "npmIwwId",
    "IWWIMP": "impIwwProjId",
    "IWWLIVE": "liveIwwProjId",
    "IWWPORTSNPM": "npmIwwPortsId",
    "IWWPORTSLIVE": "liveIwwPortsProjId",
    "IWWPORTSIMP": "impIwwPortsProjId",
    "AIRPORTSNPM": "npmAirportsId",
    "AIRPORTSLIVE": "liveAirportsProjId",
    "AIRPORTSIMP": "impAirportsProjId",
    "SEAPORTSNPM": "npmSeaportsId",
    "SEAPORTSLIVE": "liveSeaportsProjId",
    "SEAPORTSIMP": "impSeaportsProjId",
    "FREIGHTNPM": "npmFreigthId",
    "FREIGHTLIVE": "liveFreightProjId",
    "FREIGHTIMP": "impFreightProjId",
    "ROADSSBORDERNPM":"npmRoadsBorderCrossId",
    "RAILWAYSBORDERNPM":"npmRwBorderCrossId"
}
export const UrlServicesTypeTrasnporte = {
    87: "https://todis.transport-community.org/server/rest/services/Todis_Roads/MapServer/0/query",
    // 87: "https://arcgis-itconsulting.idom.com/server/rest/services/TODIS/Todis_Roads/MapServer/0/query",
    // 88: "https://todis.transport-community.org/server/rest/services/TODIS/Todis_Railway/MapServer/4/query",
    88: "https://todis.transport-community.org/server/rest/services/Todis_Railways/MapServer/4/query",
    // 89: "https://todis.transport-community.org/server/rest/services/TODIS/Todis_Ports/MapServer/1/query",
    89: "https://todis.transport-community.org/server/rest/services/Todis_Freight/MapServer/1/query",
    // 90: "https://todis.transport-community.org/server/rest/services/TODIS/Todis_Ports/MapServer/0/query",
    90: "https://todis.transport-community.org/server/rest/services/Todis_Airports/MapServer/0/query",
    // 91: "https://todis.transport-community.org/server/rest/services/TODIS/Todis_IWW/MapServer/4/query",
    91: "https://todis.transport-community.org/server/rest/services/Todis_IWW/MapServer/11/query",

    143:"https://todis.transport-community.org/server/rest/services/Todis_Seaports/MapServer/2/query",

    144:"https://todis.transport-community.org/server/rest/services/Todis_IWW_Ports/MapServer/3/query", 
    146:"https://todis.transport-community.org/server/rest/services/Todis_Border/MapServer/2/query",
    153:"https://todis.transport-community.org/server/rest/services/Todis_Border/MapServer/0/query",   
}

export const UrlServicesTypeTrasnporteName = {
    87: "routename",
    88: "routename",
    89: "name",
    90: "name",
    91: "routename",
    143:"name",
    144:"name",
    146:"node_name",
    153:"node_name"
}

export const UrlServicesNode = {
    87: "https://todis.transport-community.org/server/rest/services/Todis_Roads_LRS/MapServer/11/query",
    // 87: "https://arcgis-itconsulting.idom.com/server/rest/services/TODIS/Todis_Roads/MapServer/11/query",
    // 88: "https://todis.transport-community.org/server/rest/services/TODIS/Todis_Railway/MapServer/0", 
    88: "https://todis.transport-community.org/server/rest/services/Todis_Railways/MapServer/0/query",  
    // 91: "https://todis.transport-community.org/server/rest/services/TODIS/Todis_IWW/MapServer/7/query" 
    91: "https://todis.transport-community.org/server/rest/services/Todis_IWW/MapServer/0/query"  
}

export const UrlServicesfilterNode = {
    87: "route_id",
    88: "route_id",    
    91: "iww_id"   
}
export const UrlServicesGraphic = {
    87: "https://todis.transport-community.org/portal/apps/dashboards/7a786a621876492ea044ab54eed66db5",   
    88: "https://todis.transport-community.org/portal/apps/dashboards/ab075b5f50644f289c6350a73bcd9ae3",
    3: "https://todis.transport-community.org/server/rest/services/TODIS/Todis_EUACQUIS_Services/MapServer/0/query"
}
export const UrlServicesEUACQUIS = {
    "ByRP": "https://todis.transport-community.org/portal/apps/dashboards/e0e4a781512d431db7226bc5900cc277",
   /*overal*/ "BySector": "https://todis.transport-community.org/portal/apps/dashboards/6efb4cda017549aeb7fe72b25c993c63",
    "ByRegulatory": "https://todis.transport-community.org/portal/apps/dashboards/becfeb8d034f4d3db5fedeac303dec77",
    "ByTypeofAct": "https://todis.transport-community.org/portal/apps/dashboards/d5479c9dfaf4413cb05d73537827b84c",
    /*Others*/"NoBarchart": "https://todis.transport-community.org/portal/apps/dashboards/eba8a69cd46a4651a11a6720a36ba3e7",
    "projectmodule": "https://todis.transport-community.org/portal/apps/dashboards/6aa825a111e94dd3a2c095cf3f37a592",
    "ServicesMapServer":"https://todis.transport-community.org/server/rest/services/Todis_EUACQUIS_Services/MapServer/0",
    "ServicesBorderMapServer":"https://todis.transport-community.org/server/rest/services/Todis_Backgrounddata/MapServer/13",
    "Servicescity":"https://todis.transport-community.org/server/rest/services/Todis_Backgrounddata/MapServer/11",
    "ServiceBorderMapaBase":"https://todis.transport-community.org/server/rest/services/Todis_Backgrounddata/MapServer"
//     "ByRP": "https://todis.transport-community.org/portal/apps/dashboards/e0e4a781512d431db7226bc5900cc277",
//    /*overal*/ "BySector": "https://todis.transport-community.org/portal/apps/dashboards/6efb4cda017549aeb7fe72b25c993c63",
//     "ByRegulatory": "https://todis.transport-community.org/portal/apps/dashboards/becfeb8d034f4d3db5fedeac303dec77",
//     "ByTypeofAct": "https://todis.transport-community.org/portal/apps/dashboards/d5479c9dfaf4413cb05d73537827b84c",
//     /*Others*/"NoBarchart": "https://todis.transport-community.org/portal/apps/dashboards/eba8a69cd46a4651a11a6720a36ba3e7",
//     "ServicesMapServer":"https://todis.transport-community.org/server/rest/services/Todis_EUACQUIS_Services/MapServer/0",
//     "ServicesBorderMapServer":"https://todis.transport-community.org/server/rest/services/Todis_Backgrounddata/MapServer/13",
//     "Servicescity":"https://todis.transport-community.org/server/rest/services/Todis_Backgrounddata/MapServer/11"

}

export const createRequestURLs = {
    "boundaries": "https://todis.transport-community.org/server/rest/services/Todis_Backgrounddata/MapServer/22",
}

export const Filter = {
    "npm_road_id":"todis.todis.roads_npm_section_view.",
    "live_road_proj_id":"todis.todis.roads_live_pm_section_view.",
    "npm_rw_id":"todis.todis.railways_npm_section_view.",
    "live_rw_proj_id":"todis.todis.railways_live_pm_section_view.",
    "npm_iww_id":"todis.todis.iww_npm_section_view.",
    "live_iww_proj_id":"todis.todis.iww_live_pm_section_view.",

}
export const FilterServicesAdd = {
    "npm_road_id":"https://todis.transport-community.org/server/rest/services/Todis_Roads/MapServer/12",
    "live_road_proj_id":"https://todis.transport-community.org/server/rest/services/Todis_Roads/MapServer/12",
    "npm_rw_id":"https://todis.transport-community.org/server/rest/services/Todis_Railways/MapServer/3",
    "live_rw_proj_id":"https://todis.transport-community.org/server/rest/services/Todis_Railways/MapServer/3"
}
export const URLPortal = {
    "UrlPortal":"https://todis.transport-community.org/portal",
    "UrlServicioToken":"https://todis.transport-community.org/server/rest/services/",
}